import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { ErrorMessage } from '../../common/ErrorMessage';
import ProgramSection from './ProgramSection';
import { WarningMessage } from '../../common/WarningMessage';

function ProgramSectionContainer(props) {
  const { verifyOnClick, apiResponse, apiError } = props;
  const { channel, isMobile } = props;

  return (
    <Grid container xs={12}>
      { apiError && <ErrorMessage />}
      { !apiError
      && apiResponse
      && (
        <ProgramSection
          apiResponse={apiResponse}
          verifyOnClick={verifyOnClick}
          isMobile={isMobile}
          channel={channel}
        />
      )}
    </Grid>
  );
}

ProgramSectionContainer.propTypes = {
  verifyOnClick: PropTypes.func,
  channel: PropTypes.string,
  isMobile: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  apiResponse: PropTypes.objectOf(PropTypes.any),
  apiError: PropTypes.shape({
    showRedirectAlert: PropTypes.bool,
  })
};
ProgramSectionContainer.defaultProps = {
  verifyOnClick: () => {},
  channel: '',
  isMobile: false,
  apiResponse: null,
  apiError: false,
};

export default (ProgramSectionContainer);
